import styled from "styled-components";
import { useEffect } from "react";

import Crescevendas from "../../assets/imagens/logosParceiros/Logo Crescevendas.webp";
import Elgin from "../../assets/imagens/logosParceiros/Logo Elgin.webp";
import Gertec from "../../assets/imagens/logosParceiros/Logo Gertec.webp";
import GetNet from "../../assets/imagens/logosParceiros/Logo GetNet.webp";
import Mercafacil from "../../assets/imagens/logosParceiros/Logo Mercafacil.webp";
import Rede from "../../assets/imagens/logosParceiros/Logo Rede.webp";
import Scanntech from "../../assets/imagens/logosParceiros/Logo Scanntech.webp";
import Tectoy from "../../assets/imagens/logosParceiros/Logo Tectoy.webp";
import Stone from "../../assets/imagens/logosParceiros/Logo-Stone.webp";
import Conciflex from "../../assets/imagens/logosParceiros/Logo Conciflex.png";
import Fiserv from "../../assets/imagens/logosParceiros/Logo Fiserv.png";
import Goomer from "../../assets/imagens/logosParceiros/Logo Goomer.png";
import iMendes from "../../assets/imagens/logosParceiros/Logo iMendes.png";
import ValorTributario from "../../assets/imagens/logosParceiros/Logo Valortributario.png";
import Wabiz from "../../assets/imagens/logosParceiros/Logo Wabiz.png";

const imagens = [
  { src: Crescevendas, key: 1, alt: "Crescevendas" },
  { src: Elgin, key: 2, alt: "Elgin" },
  { src: Gertec, key: 3, alt: "Gertec" },
  { src: GetNet, key: 4, alt: "GetNet" },
  { src: Mercafacil, key: 5, alt: "Mercafacil" },
  { src: Rede, key: 6, alt: "Rede" },
  { src: Scanntech, key: 7, alt: "Scanntech" },
  { src: Tectoy, key: 8, alt: "Tectoy" },
  { src: Stone, key: 9, alt: "Stone" },
  { src: Conciflex, key: 10, alt: "Conciflex" },
  { src: Fiserv, key: 11, alt: "Fiserv" },
  { src: Goomer, key: 12, alt: "Goomer" },
  { src: iMendes, key: 13, alt: "iMendes" },
  { src: ValorTributario, key: 14, alt: "Valor Tributario" },
  { src: Wabiz, key: 15, alt: "Wabiz" },
];

const Container = styled.div`
  background-color: white;
  border-radius: var(--border-radius-m);
  overflow: hidden;
  width: 85vw;
  display: flex;
  align-self: center;
  max-width: var(--max-section-w);

  @media screen and (min-width: 993px) {
    width: 100%;
  }
`;

const LogosContainer = styled.div`
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  position: relative;

  &:before,
  &:after {
    position: absolute;
    top: 0;
    width: 250px;
    height: 100%;
    content: "";
    z-index: 2;
  }
`;

const Logo = styled.img`
  width: 5em;
  height: auto;
  margin: 0.5em 1em;
  max-height: 40px;
`;

const Slider = styled.div`
  display: inline-block;
  animation: 20s slide infinite linear;
  overflow: hidden;

  @keyframes slide {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  }
`;

export default function ListaParceiros() {
  useEffect(() => {
    window.onload = function () {
      const slider = document.querySelector(".logos-slide");

      if (slider !== null && slider !== undefined) {
        var copy = slider.cloneNode(true);
        document.querySelector(".logos").appendChild(copy);
      }
    };
  });

  return (
    <Container>
      <LogosContainer className="logos">
        <Slider className={"logos-slide"}>
          {imagens.map((x) => {
            return <Logo src={x.src} key={x.key} alt={x.alt} />;
          })}
        </Slider>
        <Slider className={"logos-slide"}>
          {imagens.map((x) => {
            return <Logo src={x.src} key={x.key} alt={x.alt} />;
          })}
        </Slider>
      </LogosContainer>
    </Container>
  );
}
